export default __webpack_public_path__ + "static/Screenshot7-0118189d9d582c7fc2a562cf97b5d76d.jpg";